import { render } from "./VuetablePaginationInfo.vue?vue&type=template&id=7d16d70f"
import script from "./VuetablePaginationInfo.vue?vue&type=script&lang=js"
export * from "./VuetablePaginationInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__